import { render, staticRenderFns } from "./BeneficiaryBenefitList.vue?vue&type=template&id=a617e2fe"
import script from "./benefit_list.js?vue&type=script&lang=js&external"
export * from "./benefit_list.js?vue&type=script&lang=js&external"
import style0 from "@/assets/styles/flexben_beneficiary.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports